import { jsx as _jsx } from "react/jsx-runtime";
const p = (d) => ["path", { d }];
const c = (cx, cy, r) => ["circle", { cx, cy, r }];
const r = (x, y, width, height, rx) => [
    "rect",
    { x, y, width, height, rx },
];
// The window frame the posture glyphs share (kit: companion, container, hud).
const frame = r(3, 4.5, 18, 15, 2);
const GLYPHS = {
    eye: [
        p("M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z"),
        c(12, 12, 2.75),
    ],
    "eye-closed": [
        p("M3.5 10.5c2 2.6 5 4.2 8.5 4.2s6.5-1.6 8.5-4.2"),
        p("M12 14.7v3.1"),
        p("M7.3 13.8l-1.5 2.6"),
        p("M16.7 13.8l1.5 2.6"),
    ],
    // kit: mic
    microphone: [r(9, 3, 6, 11, 3), p("M5.5 11.5a6.5 6.5 0 0 0 13 0"), p("M12 18v3")],
    crosshair: [
        c(12, 12, 7.5),
        p("M12 2.5v4"),
        p("M12 17.5v4"),
        p("M2.5 12h4"),
        p("M17.5 12h4"),
        p("M12 12h.01"),
    ],
    // kit: volume
    speaker: [
        p("M4 9.5h3.2L12 5.5v13l-4.8-4H4z"),
        p("M15.5 9.2a4 4 0 0 1 0 5.6"),
        p("M18.3 6.5a8 8 0 0 1 0 11"),
    ],
    // kit: volumeOff
    "speaker-off": [p("M4 9.5h3.2L12 5.5v13l-4.8-4H4z"), p("M16 9.5l5 5"), p("M21 9.5l-5 5")],
    play: [p("M8 5.5l11 6.5-11 6.5z")],
    pause: [p("M8.5 5.5v13"), p("M15.5 5.5v13")],
    replay: [p("M3 4.5v5.5h5.5"), p("M4.9 15a8 8 0 1 0 1.6-8.2L3 10")],
    lock: [r(5, 10.5, 14, 10, 2), p("M8 10.5V8a4 4 0 0 1 8 0v2.5")],
    // Ported for "What I can see" (E09-S6-T1): the redaction summary's mark and the empty view's.
    shield: [
        p("M12 3l7.5 3v5.6c0 4.3-3 7.9-7.5 9.4-4.5-1.5-7.5-5.1-7.5-9.4V6L12 3z"),
        p("M8.8 12l2.3 2.3 4.2-4.4"),
    ],
    scan: [
        p("M4 8V5.5A1.5 1.5 0 0 1 5.5 4H8"),
        p("M16 4h2.5A1.5 1.5 0 0 1 20 5.5V8"),
        p("M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H16"),
        p("M8 20H5.5A1.5 1.5 0 0 1 4 18.5V16"),
        p("M7.5 12h9"),
    ],
    check: [p("M5 12.5l4.5 4.5L19 7.5")],
    alert: [p("M12 3.8L21.5 20h-19L12 3.8z"), p("M12 10v4.5"), p("M12 17.3h.01")],
    // kit: chevronDown. Points down; rotate it with CSS for the other directions.
    chevron: [p("M6 9l6 6 6-6")],
    // kit: x
    close: [p("M6 6l12 12"), p("M18 6L6 18")],
    copy: [
        r(8.5, 8.5, 12, 12, 2),
        p("M15.5 8.5V5.5a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3"),
    ],
    download: [p("M12 3.5v12"), p("M7 11l5 5 5-5"), p("M4.5 20.5h15")],
    // kit: external
    "pop-out": [p("M14 4.5h5.5V10"), p("M19.5 4.5l-8 8"), p("M11 6.5H5.5v12h12V13")],
    // pop-out reversed: the same frame, the arrow coming back in.
    dock: [p("M10 9.5V14h4.5"), p("M19.5 4.5L10 14"), p("M11 6.5H5.5v12h12V13")],
    keyboard: [
        r(2.5, 6, 19, 12, 2),
        p("M6 10h.01"),
        p("M10 10h.01"),
        p("M14 10h.01"),
        p("M18 10h.01"),
        p("M8 14h8"),
    ],
    expand: [p("M14.5 4.5h5v5"), p("M19.5 4.5l-6 6"), p("M9.5 19.5h-5v-5"), p("M4.5 19.5l6-6")],
    // kit: sliders — the glyph on the header's settings menu button in the mockups.
    menu: [p("M4 7h8"), p("M16 7h4"), p("M4 17h3"), p("M11 17h9"), c(14, 7, 2), c(9, 17, 2)],
    // Postures. The orb is the assistant folded down to its disc and ring, with no window around it;
    // the others are the window frame, with what the assistant occupies drawn inside it.
    orb: [c(12, 12, 8.5), c(12, 12, 4.5)],
    hud: [frame, r(12.5, 11.5, 6, 5.5, 1)],
    companion: [frame, p("M14.5 4.5v15")],
    container: [frame, r(6.5, 8.5, 7, 7, 1)],
    // Ported for the stepper (E09-S4-T1): its heading glyph, an escalation's flag, and the tag of a
    // step the user confirmed.
    route: [c(6, 5, 2), c(18, 19, 2), p("M6 7v3.5a3.5 3.5 0 0 0 3.5 3.5h5a3.5 3.5 0 0 1 3.5 3")],
    flag: [p("M5.5 21V4"), p("M5.5 4.5H17l-2.2 3.7L17 12H5.5")],
    user: [c(12, 8, 3.5), p("M5 20.5a7 7 0 0 1 14 0")],
    // Ported for the curriculum (E09-S5-T4): its completed tick and its heading glyph.
    // kit: checkCircle
    "check-circle": [c(12, 12, 9), p("M8 12.3l2.8 2.8L16.2 9.5")],
    training: [
        p("M2.5 9.5L12 5l9.5 4.5L12 14 2.5 9.5z"),
        p("M6.5 11.7v4.3c1.5 1.4 3.4 2 5.5 2s4-.6 5.5-2v-4.3"),
        p("M21.5 9.5v5"),
    ],
    // Ported for the citation chip (E09-S3-T3): the page of the guide a sentence cites.
    page: [p("M7 3.5h7l4 4v13H7z"), p("M14 3.5v4h4"), p("M10 12.5h5"), p("M10 16h5")],
    // Ported for the open loops (E09-S4-T5): the heading glyph, an open ring.
    loop: [c(12, 12, 8.5)],
    // Ported for the nudges (E09-S4-T4): the quiet line's mark and the stop card's.
    info: [c(12, 12, 9), p("M12 11v5.5"), p("M12 7.7h.01")],
    stop: [
        p("M8.4 3h7.2L21 8.4v7.2L15.6 21H8.4L3 15.6V8.4L8.4 3z"),
        p("M12 8v4.5"),
        p("M12 15.8h.01"),
    ],
    // Ported for the step detail (E09-S4-T2): the mark on a decision's option. kit: arrowRight
    "arrow-right": [p("M5 12h14"), p("M13 6l6 6-6 6")],
    // Ported for the supervisory record (E09-S6-T4): its heading glyph, and the glyphs for a clip
    // (kit: film), a note and a navigation entry.
    list: [
        p("M9 6.5h11"),
        p("M9 12h11"),
        p("M9 17.5h11"),
        p("M4.5 6.5h.01"),
        p("M4.5 12h.01"),
        p("M4.5 17.5h.01"),
    ],
    film: [r(3, 5.5, 13, 13, 2), p("M16 10.5l5-3v9l-5-3")],
    pencil: [
        p("M4 20l1.2-4.4L16.6 4.2a1.6 1.6 0 0 1 2.3 0l.9.9a1.6 1.6 0 0 1 0 2.3L8.4 18.8 4 20z"),
        p("M14.5 6.3l3.2 3.2"),
    ],
    navigate: [p("M12 3l7 17-7-4-7 4 7-17z")],
};
/** Every icon name, in the order of the set above. */
export const iconNames = Object.keys(GLYPHS);
export function Icon({ name, title, size = 16, className }) {
    const label = title === undefined || title === "" ? undefined : title;
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: size, height: size, fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", focusable: "false", className: className === undefined ? "wp-icon" : `wp-icon ${className}`, ...(label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label }), children: GLYPHS[name].map((shape, i) => {
            switch (shape[0]) {
                case "path":
                    return _jsx("path", { ...shape[1] }, i);
                case "circle":
                    return _jsx("circle", { ...shape[1] }, i);
                case "rect":
                    return _jsx("rect", { ...shape[1] }, i);
            }
        }) }));
}
//# sourceMappingURL=index.js.map